import * as actionTypes from './actionTypes';
import { brandVehicleService } from './services';
import { fetchValidateAccess } from '@app/src/common/session';

const fetchBrandVehicleRequest = () => ({
  type: actionTypes.FETCH_BRAND_VEHICLE_REQUEST
});

const fetchBrandVehicleSuccess = (data) => ({
  type: actionTypes.FETCH_BRAND_VEHICLE_SUCCESS,
  data
});

const fetchBrandVehicleFailure = () => ({
  type: actionTypes.FETCH_BRAND_VEHICLE_FAILURE
});

const setBrandVehicleMessage = (message?: string) => ({
  type: actionTypes.SET_BRAND_VEHICLE_MESSAGE,
  message
});

export const clearBrandVehicleMessage = () => ({
  type: actionTypes.CLEAR_BRAND_VEHICLE_MESSAGE
});

export const clearBrandVehicleData = () => ({
  type: actionTypes.CLEAR_BRAND_VEHICLE_DATA
});

export const setBrandVehicleSelected = (selected: string) => ({
  type: actionTypes.SET_BRAND_VEHICLE_SELECTED,
  selected
});

export const clearBrandVehicleSelected = () => ({
  type: actionTypes.CLEAR_BRAND_VEHICLE_SELECTED
});

export const fetchBrandVehicle = (vehicleTypeId: number, brandName: string, flag?: string): Function => {
  return async dispatch => {
    dispatch(fetchBrandVehicleRequest());
    await dispatch(fetchValidateAccess());
    try {
      const data = await brandVehicleService.get(vehicleTypeId, brandName, flag);
      dispatch(fetchBrandVehicleSuccess(data));
      dispatch(setBrandVehicleMessage(data && data.length === 0 && 'No se encontraron resultados.'));
    } catch (e) {
      dispatch(fetchBrandVehicleFailure());
    }
  }
};
